export default {
  menuHide: false,
  mainMenu: 'welcome',
  zIndex: 10050,
  maxZIndex: 10050,
  confirm: {
    show: false
  },
  alert: {
    show: false
  },
  loading: {
    show: false,
    msg: '加载中，请稍后... ',
    html: null
  },
  toast: {
    show: false,
    msg: '',
    timeout: 1500
  },

  groups: [],
  currentGroup: null,

  selectImgWin: {
    show: false,
    multi: false,
    ok: null,
    cancel: null
  },
  selectArticleWin: {
    show: false,
    multi: false,
    ok: null,
    cancel: null
  },
  selectVideoWin: {
    show: false,
    multi: false,
    ok: null,
    cancel: null
  },
  selectAudioWin: {
    show: false,
    multi: false,
    ok: null,
    cancel: null
  },
  selectModel3dWin: {
    show: false,
    multi: false,
    ok: null,
    cancel: null
  },
  selectUnity3dWin: {
    show: false,
    multi: false,
    ok: null,
    cancel: null
  },
  player: {
    show: false,
    title: '视频预览'
  },
  uploadImgWin: false,
  uploadImgWinConfig: {},
  loginUser: {},
  permission: null
}
